<template>
  <v-app>
    <div class="app">
      <nav-bar>
        <template v-slot:logo>
          <router-link to="/" class="menu-link">LCM</router-link>
        </template>
        <router-link to="/" class="menu-link">Home</router-link>
        <router-link to="/about" class="menu-link">About</router-link>
        <router-link to="/drupal" class="menu-link">Drupal</router-link>
        <router-link to="/wordpress" class="menu-link">Wordpress</router-link>
        <router-link to="/animation" class="menu-link">Animation</router-link>
        <router-link to="/js" class="menu-link">Vue / React</router-link>
      </nav-bar>
      <transition name="page-fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </v-app>
</template>

<script>
import navBar from "@/components/NavBar";

export default {
  name: "App",
  components: {
    navBar,
  },

  data: () => ({
    //
  }),
};
</script>
<style lang="scss">
html,
.root {
  line-height: 1.5;

  font-size: 16px;

  @media (min-width: 992px) {
    font-size: 18px;
  }
  @media (min-width: 1400px) {
    font-size: 20px;
  }
  @media (min-width: 1600px) {
    font-size: 22px;
  }
}
.v-application--wrap {
  .app {
    font-family: "Nunito Sans", sans-serif;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

h1,
.h1 {
  font-size: 4.6111111rem;
  line-height: 6rem;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
  font-weight: 800;
}
h2,
.h2 {
  font-size: 2.7777777rem;
  line-height: 3rem;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  font-weight: 800;
}
h3,
.h3 {
  font-size: 1.6666668rem;
  line-height: 3rem;
  margin-top: 1.5rem;
  margin-bottom: 0rem;
  font-weight: 800;
}
h4,
.h4 {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 0rem;
  font-weight: 800;
}
h5,
.h5 {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 0rem;
  font-weight: 800;
}

p,
ul,
ol,
pre,
table,
blockquote {
  margin-top: 0rem;
  margin-bottom: 1.5rem;
  line-height: 1.75rem;
}
ul ul,
ol ol,
ul ol,
ol ul {
  margin-top: 0rem;
  margin-bottom: 0rem;
}

/* Let's make sure all's aligned */
hr,
.hr {
  border: 1px solid;
  margin: -1px 0;
}
a,
b,
i,
strong,
em,
small,
code {
  line-height: 0;
}
sub,
sup {
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}

p strong {
  font-weight: 800;
}

body {
  background-color: #000;
}
.app {
  overflow: hidden;
}
.page {
  display: block;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  vertical-align: top;
}

a {
  color: hotpink;
  text-decoration: none;
}

.page-fade-enter-active,
.page-fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease-out;
}

.page-fade-enter,
.page-fade-leave-active {
  opacity: 0;
}
</style>
